import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { Observer, observer } from "mobx-react-lite";
import CustomerRefundsViewModel from "viewModels/finance/customerRefunds/customerRefundsViewModel";

const CustomerRefundsView: ViewComponent<CustomerRefundsViewModel> = observer(({ vm }) => {
  return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
});

registerView(CustomerRefundsView, CustomerRefundsViewModel);
